import React from 'react'
import { Layout } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import Slider from 'app/theme/slider'
import BackgroundCover from 'app/theme/BackgroundCover'
import RecentActivations from './RecentActivations'
import useLeadModal from './useLeadModal'
import NavbarFixed from 'app/theme/NavbarFixed'
import { Mail, Phone } from 'react-feather'

import bannerImg from './img/hello-kitty-activation.png'
import logoImg from './img/logo.png'
import donutTruck from 'assets/svg/donut-truck.svg'
import microphone from 'assets/svg/mic.svg'
import mapMarker from 'assets/svg/map-icon.svg'
import foodTruck from 'assets/svg/pink-truck.svg'
import forkKnife from 'assets/svg/fork-knife.svg'
import hotDogBike from 'assets/svg/hot-dog-bike.svg'
import walkingWatermelon from 'assets/svg/walking-watermelon.svg'
import document from 'assets/svg/document.svg'
import megaphone from 'assets/svg/megaphone.svg'
import camera from 'assets/svg/camera-old.svg'
import graduationCap from 'assets/svg/graduation-cap.svg'
import guarantee from 'assets/svg/guarantee.svg'
import illustration from 'assets/svg/truck-illustration.svg'
import grid1 from 'assets/img/decade-grid-1.png'
import grid2 from 'assets/img/decade-grid-2.png'
import grid3 from 'assets/img/decade-grid-3.png'
import grid4 from 'assets/img/decade-grid-4.png'
import grid5 from 'assets/img/decade-grid-5.png'
import grid6 from 'assets/img/decade-grid-6.png'
import clutchAward from 'assets/img/clutch-award.png'
import exAward from 'assets/img/ex-award.png'
import aaaAward from 'assets/img/aaa-award.png'
import scaAward from 'assets/img/sca-award.png'
import eeaAward from 'assets/img/eea-award.png'
import budweiser from './img/logos/budweiser.png'
import pepsi from './img/logos/pepsi.png'
import notco from './img/logos/notco.png'
import impossible from './img/logos/impossible.png'
import sony from './img/logos/sony.png'
import bumble from './img/logos/bumble.png'
import helloKitty from './img/logos/hello-kitty.png'
import vote from './img/logos/vote.png'
import barbie from './img/logos/barbie.png'
import ciroc from './img/logos/ciroc.png'
import shakeshack from './img/logos/shakeshack.png'
import walmart from './img/logos/walmart.png'

import styles from './AgencyPage.module.css'

const capabilities = [
  {
    index: 0,
    title: "Vehicles",
    description: "Get access to thousands of food trucks, trailers, carts, and more.",
    image: foodTruck,
  }, {
    index: 1,
    title: "Culinary Development",
    description: "Create a menu that pulls in a crowd and excites their sense of sight, smell, and taste.",
    image: forkKnife,
  }, {
    index: 2,
    title: "Fabrication",
    description: "From vehicle wraps to branded physical assets, we’ll make your activation come alive.",
    image: hotDogBike,
  }, {
    index: 3,
    title: "Creative Design",
    description: "Craft an experience that makes a strong and memorable impression.",
    image: walkingWatermelon,
  }, {
    index: 4,
    title: "Locations & Permitting",
    description: "Show up exactly where your customers are, anywhere in the US, Canada, and Europe.",
    image: document,
  }, {
    index: 5,
    title: "Field Staffing",
    description: "Event managers, tour managers, producers, brand ambassadors, and culinary teams.",
    image: megaphone,
  }, {
    index: 6,
    title: "Content Creation",
    description: "Capture and share the best micro-moments of the campaign.",
    image: camera,
  }, {
    index: 7,
    title: "Research & Discovery",
    description: "Make sure you’re set up for success before any huge investments.",
    image: graduationCap,
  }, {
    index: 8,
    title: "Full Strategy Creation",
    description: " Tap into over a decade of experiential marketing knowledge.",
    image: guarantee,
  },
]

const menuItems = [
  {
    title: 'Clients & Stats',
    url: `#clients`,
  },
  {
    title: 'Capabilities & Expertise',
    url: `#capabilities`,
  },
  {
    title: 'Awards',
    url: `#awards`,
  },
  {
    title: 'Case Studies',
    url: `#case-studies`,
  },
]

let agencyMetaTags = JSON.stringify({
  "@context": "http://schema.org",
  "@type": "Organization",
  "knowsLanguage": "en-US",
  "knowsAbout": [
    "https://www.wikidata.org/wiki/Q3303463",
    "https://www.wikidata.org/wiki/Q9592701"
  ],
  "url": "https://roaminghunger.com/experiential-marketing-agency/",
  "description": "Welcome to RMNG, Roaming Hunger's Experiential Marketing Agency. We work with brands to launch pop-up experiential marketing campaigns that go anywhere, draw attention in a big way, and satisfy customers’ appetites for unique brand experiences.",
  "name": "RMNG",
  "sameAs": [
    "https://rmng.co/",
    "https://www.instagram.com/rmng_agency/",
    "https://www.crunchbase.com/organization/rmng",
    "https://goo.gl/maps/DJEME8TBXhibvwSe8",
    "https://www.linkedin.com/company/rmng/",
    "https://www.youtube.com/channel/UCutORlVslPgGew-v_sMhq1Q"
  ],
  "email": "rmng@roaminghunger.com",
  "telephone": "+1-424-777-2550",
  "image": [
    {
      "@type": "ImageObject",
      "width": "1528",
      "height": "1528",
      "name": "RMNG Image Object 2",
      "url": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-1.b15c73c1.png",
      "@id": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-1.b15c73c1.png"
    },
    {
      "@type": "ImageObject",
      "width": "1532",
      "height": "1532",
      "name": "RMNG Image Object 3",
      "url": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-2.fff60824.png",
      "@id": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-2.fff60824.png"
    },
    {
      "@type": "ImageObject",
      "width": "1528",
      "height": "1528",
      "name": "RMNG Image Object 4",
      "url": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-3.87e420a3.png",
      "@id": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-3.87e420a3.png"
    },
    {
      "@type": "ImageObject",
      "width": "1528",
      "height": "1528",
      "name": "RMNG Image Object 5",
      "url": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-4.77111e7a.png",
      "@id": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-4.77111e7a.png"
    },
    {
      "@type": "ImageObject",
      "width": "1532",
      "height": "1532",
      "name": "RMNG Image Object 6",
      "url": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-5.3f453db7.png",
      "@id": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-5.3f453db7.png"
    },
    {
      "@type": "ImageObject",
      "width": "1528",
      "height": "1528",
      "name": "RMNG Image Object 7",
      "url": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-6.594b14cf.png",
      "@id": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/decade-grid-6.594b14cf.png"
    },
    {
      "@type": "ImageObject",
      "name": "RMNG Image Object 1",
      "url": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/hello-kitty-activation.9ac3b706.png",
      "@id": "https://d3hbe0kmbam4a5.cloudfront.net/assets/static/media/hello-kitty-activation.9ac3b706.png"
    }
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "availableLanguage": "en-US",
    "contactType": "Sales",
    "telephone": "+1-424-777-2550",
    "email": "rmng@roaminghunger.com",
    "name": "RMNG Contact Point",
    "url": "https://roaminghunger.com/experiential-marketing-agency/",
    "@id": "https://roaminghunger.com/experiential-marketing-agency/#ContactPoint"
  },
  "@id": "https://roaminghunger.com/experiential-marketing-agency/#Organization"
})

export default function AgencyPage() {
  const { Modal, openModal } = useLeadModal()

  return (
    <Layout>
      <Helmet>
        <title>Branded Food Truck Promotions & Experiential Marketing - Roaming Hunger</title>
        <meta name="description" content="Launch an experiential marketing campaign that goes anywhere, draws attention in a big way, and satisfies appetites for unique brand experiences." />
        <meta name="og:title" content="Branded Food Truck Promotions & Experiential Marketing"></meta>
        <script type="application/ld+json">
          {agencyMetaTags}
        </script>
      </Helmet>
      <BackgroundCover imageUrl={bannerImg}>
        <div className={styles.gradient}>
          <div className="container text-white py-20">
            <div className="xl:w-1/2">
              <img
                className={[styles.logo, "mb-6"]}
                src={logoImg}
              />
              <h1 className="font-platform leading-none text-5xl leading-tight mb-6">
                Launch branded food trucks, promotions and mobile tours. Anywhere.
              </h1>
              <p className="text-lg font-light leading-tight mb-5 leading-relaxed">
                Welcome to RMNG, Roaming Hunger's Experiential Marketing Agency.
                We work with brands to launch pop-up experiential marketing campaigns that go anywhere,
                draw attention in a big way, and satisfy customers’ appetites for unique brand experiences.
              </p>
              <button
                className="btn btn-green font-platform text-2xl px-5 py-2"
                children="Get Started"
                onClick={openModal}
              />
            </div>
          </div>
        </div>
      </BackgroundCover>
      <NavbarFixed
        bgColor="bg-blue"
        className="text-white font-normal text-md"
        buttonStyle="text-white border-white border-2"
        onButtonClick={openModal}
        menuItems={menuItems}
      />
      <div id="clients" className="bg-white py-12">
        <div className="container text-center">
          <h2 className="font-platform text-3xl text-center text-navy w-full mb-6">A Few of Our Wonderful Clients</h2>
          <Slider
            arrows={false}
            dots={true}
            slidesToShow={4}
            slidesToScroll={4}
            responsive={[{
              breakpoint: 768,
              settings: {
                dots: true,
                arrows: false,
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            }]}
          >
            <div className="flex justify-center items-center">
              <img src={budweiser} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={pepsi} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={notco} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={impossible} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={sony} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={bumble} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={helloKitty} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={vote} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={barbie} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={ciroc} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={shakeshack} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
            <div className="flex justify-center items-center">
              <img src={walmart} className={[styles.logo_images, "block m-auto"]} style={{ height: '100px'}} />
            </div>
          </Slider>
        </div>
      </div>
      <div className="container my-12">
        <h2 className="text-3xl text-navy text-center font-platform mb-6">What We Do</h2>
        <div className="grid gap-5 md:gap-10 sm:grid-cols-2 md:grid-cols-3">
          <div className="p-5 bg-white shadow border border-gray text-center">
            <img src={donutTruck} className={[styles.what_we_do_icons, 'mb-5 m-auto']} />
            <h3 className="text-lg text-center text-navy font-platform font-light">Branded Food Trucks</h3>
            <p className="text-center font-light">
              Rent experiential vehicles for any brand activation, anywhere in the US and Canada.
              We’ll source the equipment, design and wrap the vehicle, and take it anywhere your
              brand wants to show up.
            </p>
            <a className="btn btn-green text-sm mt-4 py-2 px-4" href={"/experiential-marketing-agency/branded-food-trucks/"}>
              Learn More
            </a>
          </div>
          <div className="p-5 bg-white shadow border border-gray text-center">
            <img src={microphone} className={[styles.what_we_do_icons, 'mb-5 m-auto']} />
            <h3 className="text-lg text-navy font-platform font-light">Food Truck Promotions</h3>
            <p className="text-center font-light">
              Launch an experiential campaign to create a unique brand experience. We’ll build the
              entire strategy, design the experience, source vehicles, staffing, and locations.
            </p>
            <a className="btn btn-green text-sm mt-4 py-2 px-4" href={"/experiential-marketing-agency/food-truck-promotions/"}>
              Learn More
            </a>
          </div>
          <div className="p-5 bg-white shadow border border-gray text-center">
            <img src={mapMarker} className={[styles.what_we_do_icons, 'mb-5 m-auto']} />
            <h3 className="text-lg text-center text-navy font-platform font-light">Mobile Marketing Tours</h3>
            <p className="text-center font-light">
              Take your brand on the road. We’ll organize and run all the logistics to create a
              marketing tour that fits your goals and budget. There’s no limit to where you can go.
            </p>
            <a className="btn btn-green text-sm mt-4 py-2 px-4" href={"/experiential-marketing-agency/mobile-marketing-tours/"}>
              Learn More
            </a>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-green font-platform text-2xl block m-auto mt-10 px-5 py-2"
          onClick={openModal}
        >
          Get Started
        </button>
      </div>
      <div className="container my-12">
        <h2 className="text-3xl text-navy text-center font-platform mb-6">
          Tap Into Over a Decade of Mobile Experience
        </h2>
        <p className="font-light text-lg">
          Our journey started in 2009 when we began doing experiential food truck rentals for
          marketing campaigns. It didn’t take long before we were asked to create and manage
          an entire food truck promotion, and we haven’t looked back since.
        </p>
        <p className="mt-2 font-light text-lg">
          Today we’re a full service experiential agency that can take point on everything
          your brand needs to activate a physical experience. We’ve run over 500 activations
          and worked with hundreds of brands, from up and coming startups to Fortune 100 companies.
        </p>
        <div className="mt-6 grid grid-cols-2 md:grid-cols-3 gap-6">
          <img src={grid1} className="block" />
          <img src={grid2} className="block" />
          <img src={grid3} className="block" />
          <img src={grid4} className="block" />
          <img src={grid5} className="block" />
          <img src={grid6} className="block" />
        </div>

        <button
          type="button"
          className="btn btn-green font-platform text-2xl block m-auto my-5 px-5 py-2"
          onClick={openModal}
        >
          Get Started
        </button>
      </div>
      <div className="container my-12">
        <h2 className="text-3xl text-navy text-center font-platform mb-6">Let's Go On Tour Together</h2>
        <div className="grid gap-4 md:grid-cols-3 text-center">
          <div className="p-4 bg-white shadow border border-gray">
            <h3 className="text-3xl text-center text-black font-platform font-light">564</h3>
            <p className="text-lg font-light">
              Successful Experiential Activations and Counting.
            </p>
          </div>
          <div className="p-4 bg-white shadow border border-gray">
            <h3 className="text-3xl text-center text-black font-platform font-light">11+ Years</h3>
            <p className="text-lg font-light">
              Launching Food Truck Promotions.
            </p>
          </div>
          <div className="p-4 bg-white shadow border border-gray">
            <h3 className="text-3xl text-center text-black font-platform font-light">All 50</h3>
            <p className="text-lg font-light">
              States Covered So Far.
            </p>
            <p className="text-lg font-light">
              + Canada & Europe
            </p>
          </div>
        </div>
      </div>
      <div id="capabilities" className="container my-12">
        <h2 className="text-3xl text-navy text-center font-platform mb-6">Capabilities & Expertise</h2>
        <Slider
          arrows={false}
          dots={true}
          slidesToShow={3}
          slidesToScroll={3}
          responsive={[{
            breakpoint: 768,
            settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }]}
        >
          {capabilities.map(capability => (
            <div key={capability.index} className="p-5">
              <img src={capability.image} className={[styles.capability_icons, "p-5 m-auto"]} />
              <h3 className="text-lg text-center text-navy font-platform font-light">
                {capability.title}
              </h3>
              <p className="text-center text-lg font-light">
                {capability.description}

              </p>
            </div>
          ))}
        </Slider>

        <button
          type="button"
          className="btn btn-green font-platform text-2xl block m-auto my-5 px-5 py-2"
          onClick={openModal}
        >
          Get Started
        </button>
      </div>
      <div id="awards" className="bg-white">
        <div className="container text-center py-12">
          <h2 className="text-3xl text-navy text-center font-platform mb-6">Recent Awards</h2>
          <div className="grid gap-10 md:gap-20 grid-cols-2 md:grid-cols-5">
            <div className="flex justify-center items-center">
              <img src={eeaAward} className="block" style={{ height: '100px' }} />
            </div>
            <div className="flex justify-center items-center">
              <img src={scaAward} className="block" style={{ height: '100px' }} />
            </div>
            <div className="flex justify-center items-center">
              <img src={exAward} className="block" style={{ height: '100px' }} />
            </div>
            <div className="flex justify-center items-center">
              <img src={clutchAward} className="block" style={{ height: '100px' }} />
            </div>
            <div className="flex justify-center items-center">
              <img src={aaaAward} className="block" style={{ height: '100px' }} />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-12">
        <div className="container text-center">
          <h2 className="text-3xl text-navy text-center font-platform mb-6">Our Secret Sauce Is Our People</h2>
          <img src={illustration} className={['mx-auto p-5 mb-6']} style={{ maxWidth: "600px" }} />
          <p className="text-xl font-national font-light mb-8">
            Our team of production and creative experts bring together decades of experience in the
            experiential marketing industry. Our quality and ability to deliver is why brands come
            back to us again and again.
          </p>
          <button
            type="button"
            className="btn btn-green font-platform text-2xl px-5 py-2"
            onClick={openModal}
          >
            Get Started
          </button>
        </div>
      </div>
      <div id="case-studies">
        <RecentActivations id="case-studies" />
      </div>
      <div className="bg-navy text-white text-center py-12 px-6">
        <h2 className="text-3xl font-platform mb-6">Ready to Launch an Experience?</h2>
        <p className="text-xl pb-5"><Phone className="inline" size={16} /> (424) 777-2550</p>
        <p className="text-xl pb-5"><Mail className="inline" size={16} /> rmng@roaminghunger.com</p>
        <button
          className="btn btn-blue font-platform text-2xl px-5 py-2"
          children="Get in Touch"
          onClick={openModal}
        />
      </div>
      <Modal />
    </Layout>
  )
}


